// extracted by mini-css-extract-plugin
export default {"imageWrapper":"KF-z","hovered":"LF-z","hoverImage":"MF-z","mainImage":"NF-z","imageNoBackground":"OF-z","fullSizeImage":"PF-z"};